import { render, staticRenderFns } from "./SiteDocumentViewForm.vue?vue&type=template&id=5fbd2150"
import script from "./SiteDocumentViewForm.vue?vue&type=script&lang=js"
export * from "./SiteDocumentViewForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports